const calcLength =(list)=>{
  let total = null;
  for (const [key, value] of Object.entries(list)) {
    if(Object.keys(value).length){
      total += Object.keys(value).length
    }
  }
  return total
}
const ToggleFiltersDesktopBtn = ({ label, callback,filters }) => {
  // get the total number of selected filters
  const length =calcLength(filters);
  const clickEvent = () => {
    callback(true);
  };
  return (
    <button
      type="button"
      className="button button--outline-sec"
      onClick={() => clickEvent()}
    >
     {label} {length !== null ?`(${length})` :null}
    </button>
  );
};
export default ToggleFiltersDesktopBtn;
